{
  "version": 1,
  "asset_id": "8cf5525e-6330-4103-bc33-a3bca715f80a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/8cf5525e-6330-4103-bc33-a3bca715f80a/sleeve-ugi-reflux-post-736-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/8cf5525e-6330-4103-bc33-a3bca715f80a/sleeve-ugi-reflux-post-736-480.webp",
  "original_filename": "sleeve-ugi-reflux-post-736-480.webp",
  "size": 17638,
  "content_type": "image/webp",
  "created_at": "2026-10-04T16:13:36Z"
}
